// extracted by mini-css-extract-plugin
export default {"tabs":"edit-form_tabs__Cg528"};